export const CONVERSATION_TYPE_OPTIONS = [
  "All Active Conversations",
  "05-08-25 -  2025 Swap key to key Time!",
  "04-10-25 -  New Car -  Same monthly payments!",
  "05/01/25 -  Ford Recalls of May",
  "06/15/25 -  Veterans 15% Discounts!"
];

export const TRIGGER_EVENT_OPTIONS = [
  "All Events",
  "Email Sent",
  "Email Opened",
  "Email Replied by Contact",
  "Do not Contact Mark",
  "Do not Call Mark",
  "Do not SMS Mark",
  "Last 7 days on an active conversation",
  "Last to 15 days on an active conversation",
  "Last  to 20 days on an active conversation"
];

export const SUPPRESSION_PERIOD_OPTIONS = [
  "1 day",
  "2 days",
  "3 days",
  "4 days",
  "5 days",
  "6 days",
  "1 Week",
  "2 Weeks",
  "3 Weeks",
  "4 Weeks",
  "5 Weeks",
  "1 month",
  "3 months",
  "6 months",
  "1 year"
];

export const CONTACT_FILTER_OPTIONS = [
  "All contacts",
  "All contacts in a Previous Conversation",
  "All contacts in an Active Conversation",
  "Only Orphan Contacts"
];